// extracted by mini-css-extract-plugin
export default {"dropdowns":"SearchBox__dropdowns___vmZr3"};